import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAppDispatch } from "store/hooks";
import { addErrorNotification } from "modules/notification/redux/notificationSlice";
import { setCookie } from "modules/app/utlis/cookies";
import { getAppsumoLicenseKeyApi } from "../../request";
import { Appsumo, appsumoLicenseKeyExpireTime } from "../../constants";

export const useGetAppsumoLicenseKey = (code?: string) => {
  const dispatch = useAppDispatch();

  const {
    isLoading: isGetAppsumoLicenseKeyLoading,
    isError: isGetAppsumoLicenseKeyError,
    data,
    error,
    refetch: getAppsumoLicenseKey,
  } = useQuery({
    queryKey: ["getAppSumoLicenseKey"],
    queryFn: async () => {
      if (!code) {
        return null;
      }

      const { isSuccess, message, appsumoLicenseKey } =
        await getAppsumoLicenseKeyApi(code);

      if (!isSuccess) throw new Error(message);
      return appsumoLicenseKey;
    },
  });

  useEffect(() => {
    if (!data) return;

    setCookie(Appsumo.licenseKey, data, appsumoLicenseKeyExpireTime);
  }, [data]);

  useEffect(() => {
    if (!error) return;

    dispatch(
      addErrorNotification({
        message: error.message,
      }),
    );
  }, [error, dispatch]);

  return {
    isGetAppsumoLicenseKeyLoading,
    isGetAppsumoLicenseKeyError,
    getAppsumoLicenseKey,
  };
};
